import React from 'react';
import {
	Grid,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography
} from '@material-ui/core';
import useSessionTimeout from '../../useSessionTimeout';
import { useTranslations } from 'components/utilities';
import useStyles from './styles';
import clsx from 'clsx';

const SessionConfirmationDialog = () => {
	const { t } = useTranslations();
	const classes = useStyles();
	const {
		isDialogOpen,
		handleClose,
		handleResetApp,
		counter
	} = useSessionTimeout();

	return (
		<Dialog
			open={isDialogOpen}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				{t('cars.idle_title')}
			</DialogTitle>
			<DialogContent className={clsx(classes.box, classes.flex)}>
				<Grid container>
					<Grid item xs={12}>
						<Typography align="center" className={classes.title}>
							{t('cars.idle_message')}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Typography align="center" className={classes.title}>
							{t('cars.seconds', { seconds: counter })}
						</Typography>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={handleClose}
					variant="contained"
					color="primary"
					fullWidth
				>
					{t('cars.idle_cancel')}
				</Button>
				<Button
					onClick={handleResetApp}
					variant="contained"
					color="primary"
					fullWidth
				>
					{t('cars.idle_reset_now')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SessionConfirmationDialog;
